
import { noStyleLink } from '../../style/text';
import { spacing } from '../../style/theme';
import LogoDiscord from '../svgs/logoDiscord';
import LogoInstagram from '../svgs/logoInstagram';
import LogoLinkedin from '../svgs/logoLinkedin';
import LogoX from '../svgs/logoX';
import LogoYoutube from '../svgs/logoYoutube';

export default function FooterSocials() {
  return (
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: spacing.small,
        marginTop: spacing.medium,
        a: {
          opacity: 0.6,
          transition: 'opacity 0.2s',
          '&:hover': {
            opacity: 1,
          },
        },
      }}
    >
      <a
        css={noStyleLink}
        href="https://www.youtube.com/@project_wren"
        target="_blank"
      >
        <LogoYoutube width={18} height={18} />
      </a>
      <a css={noStyleLink} href="https://x.com/project_wren" target="_blank">
        <LogoX width={18} height={18} />
      </a>
      <a
        css={noStyleLink}
        href="https://www.instagram.com/project_wren/"
        target="_blank"
      >
        <LogoInstagram width={18} height={18} />
      </a>
      <a
        css={noStyleLink}
        href="https://www.linkedin.com/company/project-wren/"
        target="_blank"
      >
        <LogoLinkedin width={18} height={18} />
      </a>
      <a
        css={noStyleLink}
        href="https://discord.com/invite/C9yARmD38e"
        target="_blank"
      >
        <LogoDiscord width={18} height={18} />
      </a>
    </div>
  );
}
